import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  SideNavigation,
  SideNavigationItem,
} from '../../components/SideNavigation';

export const FindsMenu = React.memo(() => (
  <SideNavigation>
    <SideNavigationItem isDefault to="/finds">
      <FormattedMessage id="finds.menu.all" defaultMessage="All finds" />
    </SideNavigationItem>
    <SideNavigationItem to="/finds/groups">
      <FormattedMessage id="finds.menu.groups" defaultMessage="Groups" />
    </SideNavigationItem>
  </SideNavigation>
));
